import CommonCreate from "@/components/common/Create"
import ClientForm from "../forms/ClientForm"
import { useState } from "react"
import { clientForm } from "@/utils/objects"

const ClientCreate = () => {
    const [formProp, setFormProp] = useState(clientForm)
    return (
        <CommonCreate resource="auto-service/clients" data={formProp} title="Create new client">
            <ClientForm mode="create" formProp={formProp} setFormProp={setFormProp} />
        </CommonCreate>
    )
}

export default ClientCreate